import type { User } from './user'

export enum EmailReportType {
    callReport = 'call_report',
    sickLeave = 'sick_leave',
}

export enum SickLeaveScope {
    all = 'all',
    perPolicyHolder = 'per_policy_holder',
}

export interface SickLeaveRecipient {
    policy_holder: string
    email_to: string
    email_cc?: string
}

export type SickLeaveConfig =
    | { mode: SickLeaveScope.all; email_to: string; email_cc?: string }
    | { mode: SickLeaveScope.perPolicyHolder; policy_holders: SickLeaveRecipient[] }

export interface CallReportConfig {
    email_to: string
    email_cc?: string
    allowed_policy_holders?: string[]
}

export interface EmailReportsConfig {
    call_report?: CallReportConfig
    sick_leave?: SickLeaveConfig
}

export interface Partner {
    id: string
    number: string
    owner?: User
    name: string
    avatar?: string
    tags?: string[]
    metadata?: {
        is_public?: boolean
        can_create_coupons?: boolean
        allow_quick_activation?: boolean
        allow_bulk_activation?: boolean
        can_manage_distributors?: boolean
        parent_id?: string
        email_reports?: EmailReportsConfig
        subscription_instructions: string
        subscription_fields: {
            key: string
            label: string
            required: boolean
        }[]
    }
    updated_at: string
}
